<div class="d-flex justify-content-between general_calification_wrapper">
  <div class="general-calification" *ngFor="let rating of ratings; let i = index">
    <div class="info">
      <div class="title">
        {{rating.topic__description}}
      </div>
      <div class="votes">
        {{rating.feedback_qty}} reviews
      </div>
    </div>
    <div class="rating">
      <span class="mr-2">{{rating.score_avg.toFixed(1)}}</span>
      <i class="material-icons text-pilka-md">star</i>
    </div>
  </div>
</div>
